import React from 'react'

const ChatLayout = ({children}) => {
  return (
    <>
        <section className="message-area chat-wrap">
            <div className="chat-area">
                {children}
            </div>
        </section>
    </>
  )
}

export default ChatLayout